import { ICrop, IOmniaService } from "./omnia"
import { IDashboardStock } from "./stocks/model"

import m = omnia.models

export import IFieldsService = omnia.fields.SharedFieldsService

export interface IDashboardService extends IOmniaService {

    getFieldService(): IFieldsService

    getStocks(): IDashboardStock[]
    getSeedPlans(): IDashboardSeedPlan[]
    getNutritionPlans(): IDashboardNutritionPlan[]
    getNutritionInfo(): IDashboardNutrition
    getNotifications(): HoldingNotification[]

    recheckNotifications(): PromiseLike<HoldingNotification[]>

    recalculateNMax(): ng.IPromise<any>

}


export interface IDashboardSeedPlan {
    PlanId: number
    PlanName: string
    Date?: Date
    ProductName: string
    Quantity: number
    Unit: string
    ShouldRecalculate: boolean
}

export interface IDashboardNutritionPlan {

    PlanId: number
    PlanName: string
    Type: string
    Manure: boolean

    LastCalculationDate: Date
    ShouldRecalculate: boolean

    Applications: {
        Date?: Date
        ProductName: string
        Quantity: number
        Unit: string
    }[]

}

export interface IDashboardNutritionNmax {

    GroupId: number
    GroupName: string

    NMaxAverage: number
    NRequiredAverage?: number
    NAppliedAverage?: number

    Cropping: number[]

    Crop?: ICrop

}

export interface IDashboardNutrition {

    RequirementsToRecalculate: number[]

    NMax: IDashboardNutritionNmax[]

    MMP?: {
        NLoading: number
        NLimit: number
        HasNvzRiskMap: boolean
    }

}


export import HoldingNotificationId = m.HoldingNotificationId

export interface HoldingNotification {

    FieldId: number
    CroppingId: number
    YearId: number
    NotificationId: HoldingNotificationId
    Data?: {}

}
